/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-container[_ngcontent-%COMP%]{min-height:484px}@media only screen and (max-width:600px){.main-container[_ngcontent-%COMP%]{min-height:40px!important}}\n/*# sourceMappingURL=main.component.css.map*/"];
export { styles as styles };
